import { Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppGlobalService } from 'src/app/services/app.global.service';

@Component({
  selector: 'vb-custom-method',
  templateUrl: './custom-method.component.html',
  styleUrls: ['./custom-method.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomMethodComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class CustomMethodComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private appGlobalService = inject(AppGlobalService);

  @Input() element: any;

  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  disabled: boolean;
  methodName: string;
  showMethodPopup = false;
  config: any = {};
  files: any = null;
  appId: string;
  orgId: string;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setSelectedValue(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setSelectedValue(value) {
    if (value) {
      //this.selectedAction = value;
    }
  }

  handleGetFiles(e: any) {
    /* const scssFile = e[`/src/app/${this.getFileNames().css}`];
    const tsFile = e[`/src/app/${this.getFileNames().ts}`];
    const htmlFile = e[`/src/app/${this.getFileNames().html}`];
    let dataToSend: any = {
      appId: this.appId,
      orgId: this.orgId,
      componentName: this.componentName,
      tag: `<${this.componentName.toLowerCase()} [inputParams]=\'inputParams\' (ccEvent)=\'handleEmittedEvent($event)\'></${this.componentName.toLowerCase()}>`,
      tsFile: tsFile.code,
      scssFile: scssFile.code,
      htmlFile: htmlFile.code,
      status: 'UNDER_DEVELOPMENT'
    };
    let apiConstants = ApiConstants.saveCustomComponent;
    if (this.id!=='new') {
      apiConstants = ApiConstants.updateCustomComponent;
      dataToSend.sid = this.currentSelectedComponent.sid;
    }
    this.store.dispatch(saveCustomComponent({ saveCCApiConstants: apiConstants, ccData: dataToSend })) */
  }

  openCustomCodeEditor(e: any) {
    this.config.template = 'angular';
    this.config.files = this.files;
    this.config.getFiles = this.handleGetFiles;
    this.showMethodPopup = true;
  }

  ngOnInit(): void {
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
  }
  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }

  closeDialog() {
    this.showMethodPopup = false;
  }
}
